import classNames from 'classnames';

import viewConfig from './tealium/viewConfig';
import eventConfig from './tealium/eventConfig';
export default class ObjectHelper {
  static isNull(value) {
    return typeof value === 'undefined' || value === null;
  }

  static isNullOrEmpty(value) {
    return typeof value === 'undefined' || value === null || value === '';
  }

  static nullToDefault(value, defaultValue = '') {
    return ObjectHelper.isNullOrEmpty(value) ? defaultValue : value;
  }

  static isNullOrlengthZore(value) {
    return ObjectHelper.isNullOrEmpty(value) || value.length === 0;
  }

  // merge two of more style objects
  static mergeStyleObjects(...args) {
    if (!args || args.length <= 1) {
      return args;
    }

    const styles = {};
    const styleClassNames = classNames(...args).split(' ');
    for (const styleClassName of styleClassNames) {
      styles[styleClassName] = classNames(ObjectHelper.getObjectValues(args, styleClassName));
    }
    return styles;
  }

  static getObjectValues(objects, key) {
    const values = [];
    for (const object of objects) {
      values.push(object[key] || '');
    }
    return values;
  }

  static triggerTealiumView(name, param) {
    if (window.TMS && window.TMS.trackView) {
      if (viewConfig[name] && viewConfig[name].properties) {
        var json = viewConfig[name].properties;
        if (param) {
          Object.keys(param).forEach((key) => (json[key] = param[key]));
        }
        if (json.product_subcategory) {
          json.page_subcategory = 'etb ' + json.product_subcategory;
          json.funnel_name = 'etb investment ' + json.product_subcategory;
          json.page_name = json.page_name.replace('account opening', json.product_subcategory);
        }
        console.log('TealiumView', json);
        window.TMS.trackView(json);
      }
    }
  }

  static triggerTealiumEvent(type, name, param) {
    if (window.TMS && window.TMS.trackEvent) {
      if (eventConfig[type] && eventConfig[type][name] && eventConfig[type][name].properties) {
        var json = eventConfig[type][name].properties;
        if (param) {
          Object.keys(param).forEach((key) => (json[key] = param[key]));
        }
        // if (json.product_subcategory) {
        //   json.page_subcategory = 'etb ' + json.product_subcategory;
        //   json.funnel_name = 'etb investment ' + json.product_subcategory;
        //   json.page_name = json.page_name.replace('account opening', json.product_subcategory);
        // }
        console.log('TealiumEvent', json);
        window.TMS.trackEvent(json);
      }
    }
  }

  static getCookie(objName) {
    var arrStr = document.cookie.split('; ');
    for (var i = 0; i < arrStr.length; i++) {
      var temp = arrStr[i].split('=');
      if (temp[0] === objName) {
        return unescape(temp[1]);
      } //解码
    }
    return '';
  }
  static isDspLogon = () => {
    const authTime = this.getCookie('AUTHTIME');
    console.info('AUTHTIME is in cookies: ', authTime);
    return authTime ? true : false;
    // return authTime ? false : true; // local test DSP authentication
  };
  static setCookie(name, value, domain, path, day) {
    var cookie = name + '=' + encodeURIComponent(value); //设置Cookie的名称和Cookie的值，Cookie名称为必填项。
    if (typeof day === 'number') {
      cookie += ';max-age=' + day * 60 * 60 * 24; //设置Cookie的过期事件,默认为Session
    }
    if (!path) {
      cookie += ';path=/';
    } //设置Cookie的路径，默认为 /
    if (domain) {
      cookie += ';domain=' + domain;
    } //设置Cookie的存储域，默认为当前js执行的网页的域
    document.cookie = cookie;
  }

  static getCurrentTime() {
    let d = new Date();
    let times =
      d.getFullYear() +
      '-' +
      (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) +
      '-' +
      (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) +
      'T' +
      (d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) +
      ':' +
      (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()) +
      ':' +
      (d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()) +
      'Z';
    return times;
  }

  static goToWDpage(env) {
    if (env && env === 'sit') {
      window.location.href = process.env.REACT_APP_WD_SIT_PAGE;
    } else {
      window.location.href = process.env.REACT_APP_WD_PAGE;
    }
  }
}
